<template>
  <div id="product">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center mb-4">
          <div
            class="em-check-cont m-0"
            v-if="optional.active"
            style="position: absolute; left: 15px;"
          >
            <label class="container-check product" :for="'optional_' + indexProduct">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'optional_' + indexProduct"
                v-model="optional.select"
                @click="changeParentValue('optional-select', !optional.select)"
              />
              <span class="checkmark product"></span>
              <span class="product-text">Seleccionar</span>
            </label>
          </div>

          <div class="mx-auto d-flex align-items-center">
            <div class="image-upload d-inline">
              <label class="mb-0" :for="'uploadImg' + indexProduct">
                <i
                  class="icon-cot-adjuntar pointer mr-3"
                  style="font-size: 1.2rem; cursor: pointer;"
                ></i>
              </label>
              <input
                type="file"
                :id="'uploadImg' + indexProduct"
                v-on:change="uploadImage()"
                accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/pdf, image/jpg, image/jpeg, image/png"
              />
            </div>

            <div class="dropdown d-inline">
              <i
                class="icon-cot-configuracin dropdown-toggle pointer mr-3"
                style="font-size: 1.2rem; cursor: pointer;"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              ></i>
              <div
                class="dropdown-menu shadow dropdown-add-product dropdown-add-conditions"
                aria-labelledby="dropdownMenuButton"
              >
                <li class="dropdown-item py-2">
                  <div class="em-check-cont m-0">
                    <label class="container-check ">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'option_' + indexProduct"
                        v-model="optional.active"
                        @change="changeParentValue('optional-active', optional.active)"
                      />
                      <span class="checkmark body-one"></span>
                      <span class="ml-2">Opcional</span>
                    </label>
                  </div>
                </li>
                <li class="dropdown-item py-2">
                  <div class="em-check-cont m-0">
                    <label class="container-check ">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="quantity.edit"
                        @change="changeParentValue('quantity-edit', quantity.edit)"
                      />
                      <span class="checkmark body-one"></span>
                      <span class="ml-2">Cantidad editable</span>
                    </label>
                  </div>
                </li>
                <li class="dropdown-item py-2">
                  <div class="em-check-cont m-0">
                    <label class="container-check ">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'disc_' + indexProduct"
                        @change="changeParentValue('discount-active', discount.active)"
                        v-model="discount.active"
                      />
                      <span class="checkmark body-one"></span>
                      <span class="ml-2">Descuento</span>
                    </label>
                  </div>
                </li>
                <li class="dropdown-item py-2">
                  <div class="em-check-cont m-0">
                    <label class="container-check ">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'suscription_' + indexProduct"
                        @change="changeParentValue('suscription-active', suscription.active)"
                        v-model="suscription.active"
                      />
                      <span class="checkmark body-one"></span>
                      <span class="ml-2">Suscripción</span>
                    </label>
                  </div>
                </li>
                <li class="dropdown-item py-2">
                  <div class="em-check-cont m-0">
                    <label class="container-check ">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'commission_' + indexProduct"
                        @change="changeParentValue('commission-active', commission.active)"
                        v-model="commission.active"
                      />
                      <span class="checkmark body-one"></span>
                      <span class="ml-2">Comisión</span>
                    </label>
                  </div>
                </li>
              </div>
            </div>

            <div class="dropdown d-inline" v-if="isTemplate == false">
              <i
                class="icon-cot-sumar pointer mr-3 text-black"
                style="font-size: 1.2rem; cursor: pointer;"
                :id="'dropdownMenuButton' + indexProduct"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              ></i>
              <div
                class="dropdown-menu dropdown-add-product"
                :aria-labelledby="'dropdownMenuButton' + indexProduct"
              >
                <span class="dropdown-item" @click="addItem('producto', indexProduct)">
                  <div class="d-flex align-items-center">
                    <img class="mr-2" src="@/assets/icons/plus_obscure.svg" width="10" />
                    <span>Producto/Servicio</span>
                  </div>
                </span>
                <span class="dropdown-item" @click="addItem('texto', indexProduct)">
                  <div class="d-flex align-items-center">
                    <img class="mr-2" src="@/assets/icons/plus_obscure.svg" width="10" />
                    <span>Texto</span>
                  </div>
                </span>
              </div>
            </div>

            <img
              src="@/assets/icons/arrow_up.svg"
              width="19"
              class="mr-3"
              style="cursor: pointer;"
              @click="orderItems(indexProduct, 'up')"
              v-if="isTemplate == false"
            />

            <img
              src="@/assets/icons/arrow_down.svg"
              width="19"
              class="pointer mr-3"
              style="cursor: pointer;"
              @click="orderItems(indexProduct, 'down')"
              v-if="isTemplate == false"
            />
            <i
              class="icon-cot-guardar mr-3 pointer"
              style="font-size: 1.2rem; cursor: pointer;"
              @click="storeItemAsTemplate()"
              v-if="isTemplate == false"
            ></i>
            <i
              class="icon-cot-basura pointer"
              style="font-size: 1.2rem; cursor: pointer;"
              @click="removeFromArray(indexProduct)"
              v-if="isTemplate == false"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-flex flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-row">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="card shadow-sm cotizarlo-general-wrapper">
          <div class="card-body pb-0">
            <input
              type="text"
              class="form-control product-id-input"
              placeholder="ID de producto (opcional)"
              v-model="sku"
              v-on:keyup="changeParentValue('sku', sku)"
            />
            <template v-if="!title">
              <results-component
                :array="productsArray"
                field="name"
                :classInput="'form-control input-product mt-4'"
                placeholder="Producto o Servicio"
                style="box-shadow: none !important"
                @title="title = $event"
                v-on:keyup="changeParentValue('title', title)"
                @result="submitResult($event)"
              ></results-component>
            </template>
            <div class="form-group mt-4 mb-0" v-else>
              <input
                type="text"
                class="form-control input-product mt-4"
                placeholder="Producto o Servicio asas"
                v-model="title"
                v-on:keyup="changeParentValue('title', title)"
                style="border:none !important; padding-left:0 !important;"
              />
            </div>

            <editor
              api-key="jvbyg1kg0ayvvq7pvpm411hdj0mln8dmneqf0rz4drjvncv7"
              :init="configTinymce('Descripción detallada')"
              v-model="description"
              @onFocusOut="changeParentValue('description', description)"
            />
            <div class="d-flex mt-2 flex-wrap mb-2">
              <div class="media-preview-container mr-2" v-for="(image, i) in attachments" :key="i">
                <div class="preview-container" v-if="image.type == 'image'">
                  <img :src="image.base64" />
                </div>
                <div class="preview-container" v-if="image.type != 'image'">
                  <i class="icon-cot-documento-adjunto"></i>
                </div>
                <span class="media-name">{{ image.name }}</span>
                <span class="icon-delete pointer" @click="deleteImage(i)">X</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-xl-0 mt-lg-0 mt-md-4 mt-sm-4 mt-4"
      >
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <b class="input-group-text">Categoria</b>
                </div>
                <select
                  class="input-append custom-select"
                  style="border-radius: 0 12px 12px 0; border:none !important"
                  v-model="category"
                  @change="changeParentValue('category', category)"
                >
                  <option
                    v-for="(category, index) in productCategories"
                    :key="index"
                    v-bind:value="category.id"
                  >
                    {{ category.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="form-group">
              <div class="input-group flex-nowrap d-flex">
                <div class="input-group-prepend">
                  <div class="input-group-text w-100">IVA</div>
                </div>
                <select
                  class="input-append custom-select w-100"
                  style="border-radius: 0 12px 12px 0;border:none !important;"
                  v-model="tax"
                  @change="changeParentValue('tax', tax)"
                >
                  <option :value="true">Incluir IVA</option>
                  <option :value="false">Sin IVA</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="discount.active || commission.active">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="discount.active">
            <div class="form-group">
              <div class="input-group flex-no-wrap d-flex">
                <div class="input-group-prepend">
                  <div class="input-group-text w-100">Descuento</div>
                </div>
                <input
                  type="number"
                  min="0"
                  max="100"
                  class="form-control text-right"
                  placeholder="Descuento"
                  @change="changeParentValue('discount-amount', discount.amount)"
                  v-model.number="discount.amount"
                />
                <div class="input-group-append">
                  <div class="input-group-text" style="border-radius: 0 12px 12px 0">
                    %
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="commission.active">
            <div class="form-group pr-3">
              <div class="input-group flex-nowrap d-flex">
                <div class="input-group-prepend">
                  <div class="input-group-text w-100">Comisión</div>
                </div>
                <input
                  type="number"
                  min="0"
                  max="100"
                  class="form-control text-right"
                  placeholder="Comisión"
                  @change="changeParentValue('comission-amount', commission.amount)"
                  v-model.number="commission.amount"
                />
                <div class="input-group-append">
                  <div class="input-group-text" style="border-radius: 0 12px 12px 0">
                    %
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="suscription.active">
          <div class="col-xl-8 col-lg-12 col-md-6 col-sm-12 col-12">
            <div class="form-group">
              <div class="input-group flex-nowrap d-flex">
                <div class="input-group-prepend">
                  <div class="input-group-text w-100">Suscripción con cobro</div>
                </div>
                <select
                  class="input-append custom-select"
                  style=" border-radius: 0 12px 12px 0"
                  v-model="suscription.frequency"
                  @change="changeParentValue('sucription-frecuency', suscription.frequency)"
                >
                  <option value="semanas">Semanal</option>
                  <option value="quincenas">Quincenal</option>
                  <option value="meses">Mensual</option>
                  <option value="años">Anual</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-12 col-md-6 col-sm-12 col-12">
            <div class="form-group w-100">
              <div class="input-group flex-nowrap d-flex">
                <div class="input-group-prepend">
                  <div class="input-group-text w-100">Por</div>
                </div>
                <div class="input-append" style="border-radius: 0; flex:1;">
                  <input
                    type="number"
                    min="0"
                    class="form-control text-right"
                    v-model.number="suscription.repetition"
                    style="border-radius: 0px;flex: 1;"
                    @change="changeParentValue('suscription-repetition', suscription.repetition)"
                  />
                </div>
                <div class="input-group-prepend">
                  <div class="input-group-text" style="border-radius: 0 12px 12px 0">
                    <small>{{ suscription.frequency }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="form-group">
              <div class="input-group flex-nowrap d-flex">
                <div class="input-group-prepend">
                  <div class="input-group-text w-100">
                    Precio unitario
                  </div>
                </div>

                <money
                  @change.native="changeParentValue('price', price)"
                  v-model="price"
                  v-bind="money"
                  class="form-control text-right"
                  style="border-radius:0px 0.85rem 0.85rem 0px;"
                ></money>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="form-group">
              <div class="input-group flex-nowrap d-flex">
                <div class="input-group-prepend">
                  <label class="input-group-text w-100" for="qty">
                    Cantidad
                    <b v-if="quantity.edit" class="ml-1"> editable</b>
                  </label>
                </div>
                <input
                  type="number"
                  min="1"
                  autocomplete="off"
                  class="form-control text-right shadow-sm"
                  placeholder="0"
                  style="border-radius:0px 0.85rem 0.85rem 0px;"
                  @change="changeParentValue('quantity-amount', quantity.amount)"
                  v-model="quantity.amount"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4 d-flex">
          <div class="col-12">
            <div
              class="ml-auto"
              style="background-color: #d1dae6 !important;color: #0c203d;font-size: 0.75rem; border-radius: 12px; padding:0.375rem !important; width:fit-content;"
            >
              <span style="font-weight: bold; font-size: 0.875rem"
                >Total sin IVA : $
                {{
                  notNullFunction(itemProduct.total) ? '-' : formatPrice(itemProduct.total)
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2" v-if="itemProduct.errors != null">
      <div class="col-12 d-flex justify-content-end">
        <div class="text-danger" v-html="itemProduct.errors.message"></div>
      </div>
    </div>
  </div>
</template>
<script>
import ResultsComponent from '@/components/helpers/Results';
import Editor from '@tinymce/tinymce-vue';
import { Money } from 'v-money';
import itemsService from '@/api/items';
import data from '@/mixins/data';
export default {
  mixins: [data],
  components: {
    ResultsComponent,
    editor: Editor,
    Money
  },
  beforeMount() {
    this.type = this.itemProduct.type;
    this.sku = this.itemProduct.sku;
    this.title = this.itemProduct.title;
    this.description = this.itemProduct.description;
    this.category = this.itemProduct.category;
    this.tax = this.itemProduct.tax;
    this.optional.active = this.itemProduct.optional.active;
    this.optional.select = this.itemProduct.optional.select;
    this.discount.amount = this.itemProduct.discount.amount;
    this.discount.active = this.itemProduct.discount.active;
    this.suscription.active = this.itemProduct.suscription.active;
    this.suscription.payments = this.itemProduct.suscription.payments;
    this.suscription.frequency = this.itemProduct.suscription.frequency;
    this.suscription.repetition = this.itemProduct.suscription.repetition;
    this.commission.amount = this.itemProduct.commission.amount;
    this.commission.active = this.itemProduct.commission.active;
    this.price = this.itemProduct.price;
    this.quantity.amount = this.itemProduct.quantity.amount;
    this.quantity.edit = this.itemProduct.quantity.edit;
    this.total = this.itemProduct.total;
    this.attachments = this.itemProduct.attachments;
    this.order = this.itemProduct.order;
  },
  props: {
    itemProduct: {
      type: Object,
      required: true
    },
    indexProduct: {
      type: Number,
      required: true
    },
    productsArray: {
      required: true
    },
    productCategories: {
      required: true
    },
    isTemplate: {
      type: Boolean
    }
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        suffix: '',
        precision: 2,
        masked: false
      },
      type: 'producto',
      id: this.itemProduct.id,
      sku: null,
      title: null,
      description: null,
      category: 1,
      tax: true,
      optional: {
        active: false,
        select: false
      },
      discount: {
        amount: null,
        active: false
      },
      suscription: {
        active: false,
        payments: null,
        frequency: 'meses',
        repetition: null
      },
      commission: {
        amount: null,
        active: false
      },
      price: 0,
      quantity: {
        amount: 1,
        edit: false
      },
      total: null,
      attachments: [],
      order: 0
    };
  },
  methods: {
    formatToSend() {
      let data = new FormData();
      data.append('sku', this.sku == null || this.sku == 'null' || this.sku == '' ? '' : this.sku);
      data.append('category_id', this.category);
      data.append('name', this.title);
      data.append('description', this.description);
      data.append('IVA', this.tax === true ? 1 : 0);
      data.append('unit_price', this.price);
      data.append('quantity', this.quantity.amount);
      data.append('is_optional', this.optional.active == true ? 1 : 0);
      data.append('quantity_editable', this.quantity.edit == true ? 1 : 0);
      data.append('has_discount', this.discount.active == true ? 1 : 0);
      data.append('has_subscription', this.suscription.active == true ? 1 : 0);
      data.append('has_commission', this.commission.active == true ? 1 : 0);

      let arrayAtatchments = [];
      if (this.attachments.length > 0) {
        this.attachments.forEach(element => {
          if (element.file != null) {
            arrayAtatchments.push(element.file);
          } else {
            arrayAtatchments.push(element.base64);
          }
        });
      }
      if (arrayAtatchments.length > 0) {
        arrayAtatchments.forEach((element, indexParent) => {
          data.append('attachments[' + indexParent + ']', element);
        });
      }

      /* Checar descuento */
      if (this.discount.active == true) {
        data.append('discount', this.discount.amount);
      }

      /* Checar comision */
      if (this.commission.active == true) {
        data.append('commission', this.commission.amount);
      }

      if (this.suscription.active == true) {
        data.append('frequency', this.suscription.repetition);
        data.append('period', this.suscription.frequency);
      }

      return data;
    },
    storeItemAsTemplate() {
      if (
        (this.title == null || this.title == 'null' || this.title == '') &&
        (this.description == null || this.description == 'null' || this.description == '') &&
        (this.price == null || this.price == 'null' || this.price == '')
      ) {
        this.$store.dispatch('showMessage', {
          action: 'error',
          message: 'Llena todos los campos requeridos'
        });
      } else {
        if (this.title.length >= 45) {
          this.$store.dispatch('showMessage', {
            action: 'error',
            message: 'El nombre del producto no puede exceder los 45 caracteres'
          });
        } else {
          this.$store.dispatch('showLoader', { show: true });
          let data = this.formatToSend();
          itemsService
            .createProductItem(data)
            .then(() => {
              this.$store.dispatch('showLoader', { show: false });
              this.$store.dispatch('showMessage', {
                action: 'success',
                message: 'Guardado correctamente'
              });
            })
            .catch(() => {
              this.$store.dispatch('showLoader', { show: false });
            });
        }
      }
    },
    submitResult(event) {
      if (event) this.noResults = true;
      delete event.created;
      delete event.id;
      event.key = new Date().getTime();
      this.formatItemLocal(event);
    },
    /* Formatear item para agregarlo a objeto */
    formatItemLocal(item) {
      this.type = 'producto';
      this.sku = item.sku;
      this.title = item.name;
      this.description = item.description;
      this.category = item.category_id;
      this.tax = item.iva == 1 ? true : false;
      this.optional.active = item.is_optional == 1 ? true : false;
      this.optional.select = item.is_optional == 1 ? true : false;
      this.quantity.amount = item.quantity;
      this.quantity.edit = item.quantity_editable == 1 ? true : false;
      this.discount.amount = item.discount != null ? item.discount : null;
      this.discount.active = item.has_discount == 1 ? true : false;
      this.commission.amount = item.commission != null ? item.commission : null;
      this.commission.active = item.has_commission == 1 ? true : false;
      this.price = parseFloat(item.unit_price);
      this.total = 0;
      this.suscription.active = item.has_subscription == 1 ? true : false;
      this.suscription.payments = null;
      this.suscription.frequency = item.period;
      this.suscription.repetition = item.frequency;
      var tempAttatchments = [];
      try {
        var decoded = JSON.parse(item.attachments);
        if (decoded.length > 0) {
          decoded.forEach(element => {
            var tempFileName = element.split('/');
            tempAttatchments.push({
              file: null,
              base64: element,
              fileName: tempFileName[tempFileName.length - 1],
              type:
                element.toLowerCase().indexOf('jpg') > -1 ||
                element.toLowerCase().indexOf('jpeg') > -1 ||
                element.toLowerCase().indexOf('png') > -1
                  ? 'image'
                  : 'file'
            });
          });
        }
      } catch (e) {
        if (item.attachments != null) {
          if (item.attachments.length > 0) {
            item.attachments.forEach(element => {
              var tempFileName = element.url.split('/');
              tempAttatchments.push({
                file: null,
                base64: element.url,
                fileName: tempFileName[tempFileName.length - 1],
                type:
                  element.url.toLowerCase().indexOf('jpg') > -1 ||
                  element.url.toLowerCase().indexOf('jpeg') > -1 ||
                  element.url.toLowerCase().indexOf('png') > -1
                    ? 'image'
                    : 'file'
              });
            });
          }
        }
      }

      this.attachments = tempAttatchments;
      /* To do precargar attachments attachments: [],*/
      /* Emitir valores nuevos */
      this.changeParentValue('id', this.id);
      this.changeParentValue('optional-select', this.optional.select);
      this.changeParentValue('optional-active', this.optional.active);
      this.changeParentValue('quantity-edit', this.quantity.edit);
      this.changeParentValue('discount-active', this.discount.active);
      this.changeParentValue('suscription-active', this.suscription.active);
      this.changeParentValue('commission-active', this.commission.active);
      this.changeParentValue('sku', this.sku);
      this.changeParentValue('title', this.title);
      this.changeParentValue('description', this.description);
      this.changeParentValue('category', this.category);
      this.changeParentValue('tax', this.tax);
      this.changeParentValue('discount-amount', this.discount.amount);
      this.changeParentValue('comission-amount', this.commission.amount);
      this.changeParentValue('sucription-frecuency', this.suscription.frequency);
      this.changeParentValue('suscription-repetition', this.suscription.repetition);
      this.changeParentValue('price', this.price);
      this.changeParentValue('quantity-amount', this.quantity.amount);
      this.changeParentValue('attachments', this.attachments);
    },
    notNullFunction: function(value) {
      return Number.isNaN(value);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    removeFromArray(index) {
      this.$emit('delete-item', {
        index: index
      });
    },
    orderItems(index, direction) {
      this.$emit('order-item', {
        index: index,
        direction: direction
      });
    },
    addItem(type, index) {
      this.$emit('add-item', {
        type: type,
        index: index
      });
    },
    changeParentValue(field, value) {
      this.$emit('change-value', {
        field: field,
        index: this.indexProduct,
        value: value
      });
    },
    uploadImage() {
      let e = window.event;
      let file = e.target.files[0];
      let image = require('@/assets/icons/attachment.svg');
      if (file.type.indexOf('image') > -1) {
        var reader = new FileReader();
        var that = this;
        reader.onload = function(e) {
          that.attachments.unshift({
            file: file,
            base64: e.target.result,
            name: file.name,
            type: 'image'
          });
        };
        reader.readAsDataURL(file);
      } else {
        this.attachments.unshift({
          file: file,
          base64: image,
          name: file.name,
          type: 'file'
        });
      }
      this.changeParentValue('attachments', this.attachments);
    },
    deleteImage(index) {
      this.attachments.splice(index, 1);
      this.changeParentValue('attachments', this.attachments);
    }
  },
  watch: {
    title(val) {
      this.$emit('change-value', {
        field: 'title',
        index: this.indexProduct,
        value: val
      });
    },
    quantity(val) {
      this.$emit('change-value', {
        field: 'title',
        index: this.indexProduct,
        value: val
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-type {
  font-size: 2rem;
}

.title {
  font-size: 1.6rem;
  font-weight: bold;
  border-bottom: 1px solid #0c203d !important;
}

.form-control,
.blanck-input {
  border: 0;
  outline: 0;
  &:focus {
    box-shadow: 0 0 0 0 !important;
  }
}

.input-group {
  border-radius: 0.85rem;
}

.input-group-text,
.custom-select {
  // border: 0;
  &:focus,
  &.active {
    outline: none;
    box-shadow: none;
    border: none;
  }
}

.image-upload input {
  display: none;
}

.cotizacion-wrapper {
  margin-top: 30px;
}

.input-group-text {
  background-color: #d1dae6 !important;
  color: #0c203d;
  font-size: 0.75rem;
}

.description-options {
  border-bottom: 1px solid #c1c7d0;
  border-top: 1px solid #c1c7d0;
}

.input-blank {
  border: 0;
  background-color: transparent;
  box-shadow: 0 0 0 0 !important;
}

.label-text {
  color: #0c203d;
  font-size: 0.75rem;
}

.dropdown-toggle::after {
  display: none;
}
.input-group {
  box-shadow: 1px 5px 6px #0c203d17;
}
</style>
